import axios from "../../utilis/axios";

export const getVideos = async ({ tags, search, no }) => {
  console.log(tags);

  let queryString = "";
  if (tags?.length > 0) {
    queryString += tags?.map((tag) => `tags_like=${tag}`).join("&");
  }
  if (search !== "") {
    queryString += `&q=${search}`;
  }
  if (queryString === "") {
    const res = await axios.get(`/videos/?_page=${no}&_limit=5`);
    console.log(no);
    return res.data;
  } else {
    const res = await axios.get(`/videos/?${queryString}`);
    return res.data;
  }
};
